import { createTheme } from 'flowbite-react';
import { customAccordionTheme } from './flowbiteAccordionTheme';
import { tableTheme } from './tableTheme';
import { caruselTheme } from './caruselTheme';
export const componentsTheme = createTheme({
  accordion: customAccordionTheme,
  table: tableTheme,
  carousel: caruselTheme,
});
